<div class="uploadBox">
  @if (onlyDownload()) {
  <app-file-upload-container
    [formGroup]="uploadForm"
    controlName="file"
    (uploadAttachmentEmitter)="uploadFile()"></app-file-upload-container>
  } @if (uploading) {
  <mat-spinner></mat-spinner>
  }
  <p class="warning">File can be a maximum of 4MB!</p>
  <div>
    <mat-chip-listbox>
      @for (file of files(); track file.id) { @if (file) {
      <mat-chip
        class="fileChip"
        (click)="openFile(file)"
        selected>
        <mat-icon class="fileIcon">cloud_download</mat-icon>
        {{ file.name }}
      </mat-chip>
      } @if (canDelete()) {
      <mat-icon
        class="deleteButton"
        (click)="deleteFile(file)"
        >delete</mat-icon
      >
      } }
    </mat-chip-listbox>
  </div>
</div>
